/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, FC, useContext, useRef, useState } from "react";

import { MAP_TYPES } from "./constant";

const defaultLocationContextValue: any = {
  map: null,
  center: null,
  universities: null,
  selectedUniversity: null,
  mapType: MAP_TYPES.ROAD_VIEW,
  nearbyLocation: null,
  distance: null,
  nearbyLocations: null,
  nearbyLocationMarkers: null,
  inventoryMarker: null,
  regionMarker: null,
  regionSearchValue: null,
  setMap: () => {},
  setCenter: () => {},
  setUniversities: () => {},
  setSelectedUniversity: () => {},
  setMapType: () => {},
  setNearbyLocation: () => {},
  setDistance: () => {},
  setRegionSearchValue: () => {},
};

export const LocationContext = createContext<any>(defaultLocationContextValue);

export const LocationProvider: FC<any> = ({ children }) => {
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(null);
  const [universities, setUniversities] = useState<any[] | null>([]);
  const [selectedUniversity, setSelectedUniversity] = useState<any | null>(null);
  const [mapType, setMapType] = useState<any>(MAP_TYPES.ROAD_VIEW);
  const [nearbyLocation, setNearbyLocation] = useState<any>({});
  const [distance, setDistance] = useState<any>({});
  const [regionSearchValue, setRegionSearchValue] = useState<any>();
  const [queryUniversityData, setQueryUniversityData] = useState<any>();

  const nearbyLocations = useRef([]);
  const nearbyLocationMarkers = useRef([]);
  const regionMarker = useRef(null);
  const inventoryMarker = useRef(null);

  return (
    <LocationContext.Provider
      value={{
        map,
        setMap,
        center,
        setCenter,
        universities,
        setUniversities,
        selectedUniversity,
        setSelectedUniversity,
        queryUniversityData,
        setQueryUniversityData,
        mapType,
        setMapType,
        nearbyLocation,
        setNearbyLocation,
        distance,
        setDistance,
        nearbyLocations,
        nearbyLocationMarkers,
        regionMarker,
        inventoryMarker,
        regionSearchValue,
        setRegionSearchValue,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => useContext<any>(LocationContext);
